export default __webpack_public_path__ + "static/media/shootergame.7248dd25.jpg";